export default () => ({
  tableCell: {
    border: 1,
    borderColor: '#E0E0E0',
    borderStyle: 'solid',
    padding: 0,
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});



// WEBPACK FOOTER //
// ./src/screens/private/Schedules/components/ScheduleWeekItem.styles.js